import { useCallback } from 'react';
import { StorageFileAuditGrid } from '@jarvis/platform-ui';
import { listClientPortalStorageFileAudits } from '../../../api/clientPortalStorageFileAudit';

export function ClientPortalStorageFileAuditPage() {
  const loadPage = useCallback(
    (request: Parameters<typeof listClientPortalStorageFileAudits>[0]) =>
      listClientPortalStorageFileAudits(request),
    []
  );

  return (
    <div className="ops-fill-page ops-fill-page--bare">
      <div className="ops-fill-page__grid-host">
        <StorageFileAuditGrid
          loadPage={loadPage}
          stateStorageKey="webopsui:client-portal-storage-file-audit-grid"
        />
      </div>
    </div>
  );
}
